export default __webpack_public_path__ + "static/media/1894.28bc208c.png";